import { render, staticRenderFns } from "./test.vue?vue&type=template&id=40d00dc5&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Abdelaziz\\Documents\\depot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40d00dc5')) {
      api.createRecord('40d00dc5', component.options)
    } else {
      api.reload('40d00dc5', component.options)
    }
    module.hot.accept("./test.vue?vue&type=template&id=40d00dc5&", function () {
      api.rerender('40d00dc5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/test.vue"
export default component.exports